import Sider from "../../components/siderbarcomponents.jsx";
import { useState } from "react";

interface Subscription {
  empresa: string;
  representante: string;
  telefono: string;
  tarjeta: string;
  numero: string;
  fechaCorte: string;
  suscripcion: string;
}

const initialData: Subscription[] = [
  {
    empresa: "Expresso Belmira",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Bellanitas",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "---------",
    numero: "--------------------",
    fechaCorte: "-----------",
    suscripcion: "INACTIVA",
  },
  {
    empresa: "Transporte tamesis",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "------------------",
    numero: "--------------------",
    fechaCorte: "30-Feb-2025",
    suscripcion: "CANCELADA",
  },
  {
    empresa: "Sotra Peñol",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "SIN FONDOS",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
  {
    empresa: "Flota Fredonia",
    representante: "Jairo Martines Duran",
    telefono: "3105625487",
    tarjeta: "Mastercard",
    numero: "6532-3514-XXXX-XXXX",
    fechaCorte: "30-Feb-2025",
    suscripcion: "ACTIVA",
  },
];

const statusStyles: Record<string, string> = {
  ACTIVA: "text-green-600",
  INACTIVA: "text-gray-400",
  CANCELADA: "text-red-600 bg-red-100",
  "SIN FONDOS": "text-yellow-600 bg-yellow-100",
};

export default function SuscripcionesPixu() {
  const [data, setData] = useState(initialData);
  const [sortField, setSortField] = useState<keyof Subscription | null>(null);
  const [sortAsc, setSortAsc] = useState(true);

  const handleSort = (field: keyof Subscription) => {
    const isAscending = sortField === field ? !sortAsc : true;
    setSortField(field);
    setSortAsc(isAscending);

    const sortedData = [...data].sort((a, b) => {
      if (a[field] < b[field]) return isAscending ? -1 : 1;
      if (a[field] > b[field]) return isAscending ? 1 : -1;
      return 0;
    });

    setData(sortedData);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sider />

      <div className="flex-1 p-6">
        <h2 className="text-[18px] font-semibold text-textSubtitle mt-10 mb-6">
          Control de Suscripciones PIXU
        </h2>

        <div className="p-4 bg-white shadow-md rounded-lg h-[85%] overflow-auto">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b py-4 cursor-pointer">
                  {[
                    "empresa",
                    "representante",
                    "telefono",
                    "tarjeta",
                    "numero",
                    "fechaCorte",
                    "suscripcion",
                  ].map((key) => (
                    <th
                      key={key}
                      onClick={() => handleSort(key as keyof Subscription)}
                      className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-semibold"
                    >
                      {key.charAt(0).toUpperCase() + key.slice(1)}{" "}
                      {sortField === key ? (sortAsc ? "↑" : "↓") : ""}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    {Object.entries(row).map(([key, value]) => (
                      <td
                        key={key}
                        className={`py-4 pl-6 text-left text-[14px] text-textTipic font-medium ${statusStyles[value] || ""}`}
                      >
                        {value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
